import { render } from "./PersonalDataForm.vue?vue&type=template&id=49fab42a"
import script from "./PersonalDataForm.vue?vue&type=script&lang=js"
export * from "./PersonalDataForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__